import { createElement as _createElement } from "react";
import React from "react";
//import customTypes from "@project/enums/contentsCustomType";
import ContentsTypes from "@shared/enums/contentsTypes";
import ArticleTitle from "@project/components/ArticleTitle";
import PresentationBox from "@project/components/PresentationBox";
import SubPage from "@shared/components/contents/subPage/SubPage";
import { formatPageData } from "@frontoffice/utils/templates/formatPageData";
import GeographicMap from "@project/components/GeographicMap";
import SubpageSearch from "@project/components/SubpageSearch";
import PresentationBlock from "@project/components/PresentationBlock/PresentationBlock";
import PresentationCard from "@project/components/PresentationCard/PresentationCard";
import Trombinoscope from "@project/components/Trombinoscope/Trombinoscope";
import BlockWithTitle from "@project/components/BlockWithTitle/BlockWithTitle";
import TextBlockWithTitle from "@project/components/TextBlockWithTitle/TextBlockWithTitle";
import DescriptionBlock from "@project/components/DescriptionBlock/DescriptionBlock";
import DescriptionCardWithLogo from "@project/components/DescriptionCardWithLogo/DescriptionCardWithLogo";
import ContactForm from "@project/components/ContactForm/ContactForm";
import Mailto from "@project/components/Mailto";
import Iframe from "@project/components/Iframe/Iframe";
import customTypes from "@project/enums/contentsCustomTypes.enum";
import TabsComponent from "@project/components/TabsComponent/TabsComponent";
import HorizontalInfos from "@project/components/HorizontalInfos/HorizontalInfos";
import ProductBlock from "@project/components/ProductBlock/ProductBlock";
import ContactBlock from "@project/components/ContactBlock/ContactBlock";
import SkillsTabPanel from "@project/components/SkillsTabs/SkillsTabPanel";
import AutoScrollingInfos from "@project/components/AutoScrollingInfos/AutoScrollingInfos";
import CardsGrid from "@project/components/CardsGrid/CardsGrid";
import DescriptionSection from "@project/components/DescriptionSection/DescriptionSection";
import WarningBanner from "@project/components/WarningBanner";
import DocaposteSection from "@project/components/DocaposteSection/DocaposteSection";
import ArticleCardList from "../components/ArticleCardList/ArticleCardList";
const getDynamicComponent = ({ type, value, id, index }) => {
    switch (type) {
        case customTypes.ARTICLE_SECTION:
            return _createElement(ArticleTitle, { ...value, key: id });
        case customTypes.PRESENTATION_BOX:
            return _createElement(PresentationBox, { ...value, key: id });
        case customTypes.PRESENTATION_BLOCK:
            return _createElement(PresentationBlock, { ...value, key: id });
        case customTypes.PRESENTATION_CARD:
            return _createElement(PresentationCard, { ...value, key: id });
        case customTypes.TROMBINOSCOPE:
            return _createElement(Trombinoscope, { ...value, key: id });
        case ContentsTypes.SUBPAGE: {
            const { page } = value || {};
            const { image } = page || {};
            return (_createElement(SubPage, { ...value, page: { ...formatPageData(page), image }, pageVersion: page, key: id, index: index }));
        }
        case customTypes.BLOCK_WITH_TITLE:
            return _createElement(BlockWithTitle, { ...value, key: id });
        case customTypes.TEXT_BLOCK_WITH_TITLE:
            return _createElement(TextBlockWithTitle, { ...value, key: id });
        case customTypes.DESCRIPTION_BLOCK:
            return _createElement(DescriptionBlock, { ...value, key: id });
        case customTypes.DESCRIPTION_CARD_WITH_LOGO:
            return _createElement(DescriptionCardWithLogo, { ...value, key: id });
        case customTypes.TABS_COMPONENT:
            return _createElement(TabsComponent, { ...value, key: id });
        case customTypes.GEOGRAPHIC_MAP:
            return _createElement(GeographicMap, { ...value, key: id });
        case customTypes.SUBPAGE_SEARCH:
            return _createElement(SubpageSearch, { ...value, key: id });
        case customTypes.CONTACT_FORM:
            return _createElement(ContactForm, { ...value, key: id });
        case customTypes.MAILTO: {
            return _createElement(Mailto, { ...value, contentId: id, key: id });
        }
        case customTypes.IFRAME:
            return _createElement(Iframe, { ...value, key: id });
        case customTypes.HORIZONTAL_INFOS:
            return _createElement(HorizontalInfos, { ...value, key: id });
        case customTypes.HORIZONTAL_INFO_ITEM:
            return { id, ...(value || {}) };
        case customTypes.PRODUCT_BLOCK:
            return _createElement(ProductBlock, { ...value, key: id });
        case customTypes.CONTACT_BLOCK:
            return _createElement(ContactBlock, { ...value, key: id });
        case customTypes.CARDS_GRID:
            return _createElement(CardsGrid, { ...value, key: id });
        case customTypes.AUTO_SCROLLING_INFOS:
            return _createElement(AutoScrollingInfos, { ...value, key: id });
        case customTypes.SKILLS_TAB_PANEL:
            return _createElement(SkillsTabPanel, { ...value, key: id });
        case customTypes.DESCRIPTION_SECTION:
            return _createElement(DescriptionSection, { ...value, key: id });
        case customTypes.DOCAPOSTE_SECTION:
            return _createElement(DocaposteSection, { ...value, key: id });
        case customTypes.ARTICLE_CARD_LIST:
            return _createElement(ArticleCardList, { ...value, key: id });
        case ContentsTypes.WARNING_BANNER:
            return _createElement(WarningBanner, { ...value, key: id });
        case customTypes.CARDS_GRID_ITEM:
        case customTypes.AUTO_SCROLLING_INFO_ITEM:
        case customTypes.SKILL_BOX:
        case customTypes.DESCRIPTION_SECTION_ITEM:
            return { id, ...(value || {}) };
        case customTypes.ARTICLE_CARD_LIST_ITEM:
            return { id, ...(value || {}) };
        default:
            return null;
    }
};
export default getDynamicComponent;
